import React from 'react';
import formatMoney from '@ott/utility-format-money';

const getFormattedMoney = (amount: number): string => {
  return formatMoney(amount, {
    currencyCode: 'RUB',
    lang: 'ru',
    numberFormatOptions: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    asNumber: false,
    useSymbol: true,
  });
};

const getIsWebview = () => {
  return (
    navigator &&
    navigator.userAgent &&
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)
  );
};

export { getFormattedMoney, getIsWebview };
